import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareCostumerNoAbroadFuturePackageBlockData from '../../../Models/Content/SelfCareCostumerNoAbroadFuturePackageBlockData';
import SelfCareCostumerNoAbroadFuturePackageMain from "./SelfCareCostumerNoAbroadFuturePackageMain"

export default class SelfCareAbroadMarketPopularBlock extends EpiComponent<SelfCareCostumerNoAbroadFuturePackageBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return (
      <SelfCareCostumerNoAbroadFuturePackageMain context={this.getContext()} iContent={this.props.data} />
    );
  }
}
